import { EComponentTypes } from "../../../Utils/Enums";
import { InstructorModel } from "../../../Utils/Models";
import { formatDate } from "../../../Utils/Utils";
import { Vocabulary } from "../../../Utils/Vocabulary";

export const drivingHoursColumns = [
  {
    name: "incrementId",
    label: Vocabulary.order,
  },
  {
    name: "instructorName",
    label: Vocabulary.instructor,
  },
  {
    name: "startDate",
    label: Vocabulary.date,
    options: {
      customBodyRender: (startDate: Date) => {
        return formatDate(startDate);
      },
      exportValue: (startDate: Date) => startDate ? formatDate(startDate) : "",
    },
  },
  {
    name: "clientName",
    label: Vocabulary.cursant,
  },
  {
    name: "product",
    label: Vocabulary.category,
  },
  {
    name: "distanceKm",
    label: Vocabulary.distance,
  },
  {
    name: "startDate",
    label: Vocabulary.startHour,
    options: {
      customBodyRender: (date: Date) => {
        return formatDate(date, "HH:mm");
      },
      exportValue: (date: Date) => date ? formatDate(date, "HH:mm") : "",
    },
  },
  {
    name: "endDate",
    label: Vocabulary.endHour,
    options: {
      customBodyRender: (date: Date) => {
        return formatDate(date, "HH:mm");
      },
      exportValue: (date: Date) => date ? formatDate(date, "HH:mm") : "",
    },
  },
];

/**
 * Generates an array of filter objects for the driving hours report.
 *
 * @param {InstructorModel[]} instructors - The list of instructors to use for the autocomplete filter.
 *
 * @returns {Array<Filter>} An array of filter objects.
 */
export const drivingHoursFilters = (instructors: InstructorModel[]) => [
  {
    property: "instructorId",
    autocompleteFilterProperty: "instructorId",
    label: Vocabulary.instructor,
    type: EComponentTypes.AUTOCOMPLETE,
    validation: null,
    defaultValue: null,
    options: instructors,
  },
];
